import { render, staticRenderFns } from "./Asofarma.vue?vue&type=template&id=4529c146&scoped=true"
import script from "./Asofarma.vue?vue&type=script&lang=js"
export * from "./Asofarma.vue?vue&type=script&lang=js"
import style0 from "./Asofarma.vue?vue&type=style&index=0&id=4529c146&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4529c146",
  null
  
)

export default component.exports